<template>
    <div class="app">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: 'app',
    components: {},
    created: function () {},
    mounted() {
        // 针对9190活动投放地址不对，强行校验处理
        if (location.href.indexOf('http://wx.17u.cn/actgateway/act_csr/b06bb82be7ffdcc55ffadce90df2093e?historyId=178094') >= 0) {
            let url = location.href.replace('http://wx.17u.cn/actgateway/act_csr/b06bb82be7ffdcc55ffadce90df2093e?historyId=178094', 'https://wx.17u.cn/actgateway/act_csr/b06bb82be7ffdcc55ffadce90df2093e?refid=902510513')
            location.replace(url)
        }
        if (
            window._isDraftView &&
            ![
                547, 1534, 1484, 1240, 1469, 1539, 1309, 1536, 1462, 1500, 713,
                1514, 673, 1020, 1535, 557, 1526, 1501, 1189, 960, 1502, 1161,
                1400, 1537, 453, 1015, 678, 1482, 1497, 1495, 1523, 1403, 1163,
                1044, 1496,
            ].includes(parseInt(window._paid)) &&
            this.getCurrentEnv() === 'product'
        ) {
            this.canvasWM({
                content: '预览地址',
            })
        }
    },
    methods: {
        canvasWM({
            container = document.body,
            width = '280px',
            height = '200px',
            textAlign = 'center',
            textBaseline = 'middle',
            font = '18px Microsoft Yahei',
            fillStyle = 'rgba(96, 96, 96, 1)',
            content = '水印',
            rotate = '45',
            zIndex = 199999,
        } = {}) {
            const args = arguments[0]
            const canvas = document.createElement('canvas')

            canvas.setAttribute('width', width)
            canvas.setAttribute('height', height)
            const ctx = canvas.getContext('2d')

            ctx.textAlign = textAlign
            ctx.textBaseline = textBaseline
            ctx.font = font
            ctx.fillStyle = fillStyle
            ctx.rotate((Math.PI / 180) * rotate)
            ctx.fillText(content, parseFloat(width) / 2, parseFloat(height) / 2)

            const base64Url = canvas.toDataURL()
            const __wm = document.querySelector('.__wm')

            const watermarkDiv = __wm || document.createElement('div')
            const styleStr = `
                  position:fixed;
                  top:0;
                  left:25px;
                  bottom:0;
                  right:0;
                  width:100%;
                  height:100%;
                  z-index:${zIndex};
                  pointer-events:none;
                  background-repeat:repeat;
                  background-image:url('${base64Url}')`

            watermarkDiv.setAttribute('style', styleStr)
            watermarkDiv.classList.add('__wm')

            if (!__wm) {
                container.insertBefore(watermarkDiv, container.firstChild)
            }

            if (typeof module != 'undefined' && module.exports) {
                //CMD
                module.exports = this.canvasWM
            } else if (typeof define == 'function' && define.amd) {
                // AMD
                define(function () {
                    return this.canvasWM
                })
            } else {
                window.canvasWM = this.canvasWM
            }
        },
        getCurrentEnv() {
            if (location.host.indexOf('.uat.') >= 0) {
                return 'uat'
            } else if (location.host.indexOf('.qa.') >= 0) {
                return 'qa'
            } else if (location.host.indexOf('.t.') >= 0) {
                return 't'
            } else {
                return 'product'
            }
        },
    },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" type="text/stylus">
@require 'assets/style/base.styl';
@require 'assets/style/m-1px.styl';
@require 'assets/style/animate.min.css';
@require 'assets/style/custome-animate.css';

normalize();

* {
    box-sizing: border-box;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}

.app {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
}

html, body {
    font-size: 16px;
}

body.modal-open {
    position: fixed;
    width: 100%;
}
</style>
